import { combineReducers } from "redux";
import { FETCH_DIRECTIONS_REQUEST } from "./constants";
import { arrayToObject } from "../../utils/arrayToObject";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action } from "./types";
import { Direction } from "../types";

type DirectionItem = Direction & {
  isFetching: boolean;
};

type Items = {
  [key: number]: DirectionItem;
};

function items(state: Items = {}, action: Action): Items {
  switch (action.type) {
    case getSuccessActionType(FETCH_DIRECTIONS_REQUEST):
      return arrayToObject(action.payload);

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_DIRECTIONS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_DIRECTIONS_REQUEST):
    case getFailureActionType(FETCH_DIRECTIONS_REQUEST):
      return false;
    default:
      return state;
  }
}

export const directions = combineReducers({ items, isFetching });
